import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const CreateAppointmentsModalContext = createContext<ContextType | null>(null);

const CreateAppointmentsModalProvider: ComponentWithChildren = ({
  children,
}) => {
  const providerValue = useProviderValue();

  return (
    <CreateAppointmentsModalContext.Provider value={providerValue}>
      {children}
    </CreateAppointmentsModalContext.Provider>
  );
};

export const useCreateAppointmentsModalContext = () => {
  const context = useContext(CreateAppointmentsModalContext);
  if (context === undefined) {
    throw new Error(
      'the useCreateAppointmentsModalContext should be used within CreateAppointmentsModalProvider!'
    );
  }

  return context;
};

export default CreateAppointmentsModalProvider;
